import { APP } from 'libs/constants';
import apiCall from './apiRequest';
import endPoints from './endpoints';

const MS_PLANS_CA = {
  plans: [
    {
      title: 'views.msPlans.plansCardWrapper.subscriptionCard.monthly.CA.title',
      planID: 'ca-ms-monthly',
      currency: 'CAD',
      frequency: 'Monthly',
      amount: 7.99,
      tax: null,
      countryCode: 'ca',
      isRecommended: false
    },
    {
      title: 'views.msPlans.plansCardWrapper.subscriptionCard.annual.CA.title',
      tax: null,
      planID: 'ca-ms-annual',
      currency: 'CAD',
      offer: 'views.msPlans.plansCardWrapper.subscriptionCard.annual.CA.offer',
      frequency: 'Annual',
      amount: 4.26,
      countryCode: 'ca',
      isRecommended: true
    }
  ]
};

const MS_PLANS_US = {
  plans: [
    {
      title: 'views.msPlans.plansCardWrapper.subscriptionCard.monthly.US.title',
      planID: 'us-ms-monthly',
      currency: 'USD',
      frequency: 'Monthly',
      amount: 7.99,
      tax: null,
      isRecommended: false
    },
    {
      title: 'views.msPlans.plansCardWrapper.subscriptionCard.annual.US.title',
      tax: null,
      planID: 'us-ms-annual',
      currency: 'USD',
      offer: 'views.msPlans.plansCardWrapper.subscriptionCard.annual.US.offer',
      frequency: 'Annual',
      amount: 4.26,
      isRecommended: true
    }
  ]
};

function getPlanUsingPlanId(planID = '') {
  const plans = [...MS_PLANS_CA.plans, ...MS_PLANS_US.plans];
  let plan = null;
  if (planID) {
    for (let index = 0; index < plans.length; index += 1) {
      if (plans[index].planID === planID) {
        plan = {
          plans: [plans[index]]
        };
        break;
      }
    }
  }
  return plan;
}

function getPlansUsingCountryCode(countryCode = '') {
  let plans = MS_PLANS_US;
  if (countryCode && countryCode.toUpperCase() === 'CA') {
    plans = MS_PLANS_CA;
  }
  return plans;
}

export function fetchMsPlansApi({ planId = '', countryCode = '' }) {
  let plans = getPlanUsingPlanId(planId);
  if (!plans) {
    plans = getPlansUsingCountryCode(countryCode);
  }
  return Promise.resolve(plans);
}

export function checkoutMsPlanApi(plan, locale) {
  return apiCall({
    method: 'put',
    endpoint: endPoints.planCheckout,
    payload: {
      app: APP.ms,
      plan,
    },
    query: {
      locale
    }
  });
}

export default {
  fetchMsPlansApi
};



// WEBPACK FOOTER //
// ./src/api/msPlans.js